module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-shadow box-shadow--big"
  }, [_c('div', {
    staticClass: "helper__wrapper"
  }, [_c('div', {
    staticClass: "flex-row flex-start"
  }, [_c('v-checkbox', {
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "NABRZMIALE",
      "name": "left-breast-changes",
      "label": _vm.$t('NABRZMIALE')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "WKLESNIECIE",
      "name": "left-breast-changes",
      "label": _vm.$t('WKLESNIECIE')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "NAPIETA",
      "name": "left-breast-changes",
      "label": _vm.$t('NAPIETA')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "ZACZERWIENIONA",
      "name": "left-breast-changes",
      "label": _vm.$t('ZACZERWIENIONA')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "WYDZIELINA",
      "name": "left-breast-changes",
      "label": _vm.$t('WYDZIELINA')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "WGLEBIENIA",
      "name": "left-breast-changes",
      "label": _vm.$t('WGLEBIENIA')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "ZYLY",
      "name": "left-breast-changes",
      "label": _vm.$t('ZYLY')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "SUTKI_WKLESNIETE",
      "name": "left-breast-changes",
      "label": _vm.$t('SUTKI_WKLESNIETE')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "KSZTALT",
      "name": "left-breast-changes",
      "label": _vm.$t('KSZTALT')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "POMARANCZOWA",
      "name": "left-breast-changes",
      "label": _vm.$t('POMARANCZOWA')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-column",
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('v-checkbox', {
    staticClass: "fake-label row3 custom-input custom-checkbox",
    attrs: {
      "color": "main-color",
      "type": "radio",
      "value": "INNA",
      "name": "left-breast-changes",
      "label": _vm.$t('OTHER_WHAT')
    },
    on: {
      "change": _vm.updateProblems
    },
    model: {
      value: (_vm.problems),
      callback: function($$v) {
        _vm.problems = $$v
      },
      expression: "problems"
    }
  }), _vm._v(" "), (_vm.problems.includes('INNA')) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.problemCustom),
      expression: "problemCustom"
    }],
    staticClass: "el-input__inner el-input__inner--small row3",
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "placeholder": _vm.$t('INSERT_CHANGE'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.problemCustom)
    },
    on: {
      "change": _vm.updateCustomProblems,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.problemCustom = $event.target.value
      }
    }
  }) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5278a2a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/helpers/left-breast-changes-observe.vue
// module id = 1200
// module chunks = 0